const set = (prop) => (state, payload) => {
  state[prop] = payload;
};

export default {
  setTeams: set('teams'),
};
